
import './index.css'; 
import App from './App.js'; 
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { createRoot } from "react-dom/client";
import AppProviders from './app/providers/AppProviders';

const container = document.getElementById("root");
const root = createRoot(container);


root.render(
  <AppProviders>
    <App />
  </AppProviders>
);
